import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useTranslation } from 'react-i18next'

interface DeleteConfirmationDialogProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  onConfirm: () => void
  itemName?: string
  itemType?: string // e.g., "market insight", "thesis", "user"
  title?: string
  description?: string
  // Wording of the confirm button, for destructive actions that are not a
  // deletion (revoking an access leaves the row in place).
  confirmLabel?: string
}

export const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  isOpen,
  onOpenChange,
  onConfirm,
  itemName,
  itemType = 'item',
  title,
  description,
  confirmLabel,
}) => {
  const { t } = useTranslation()
  
  const defaultTitle = title || t('deleteConfirmationDialog.areYouSure')
  const translatedItemType = t(`deleteConfirmationDialog.itemTypes.${itemType}`, itemType)
  const defaultDescription = description || (
    itemName 
      ? t('deleteConfirmationDialog.defaultDescriptionWithName', { itemType: translatedItemType, itemName })
      : t('deleteConfirmationDialog.defaultDescriptionWithoutName', { itemType: translatedItemType })
  )
  const consequences = t(`deleteConfirmationDialog.consequences.${itemType}`, '')

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{defaultTitle}</AlertDialogTitle>
          <AlertDialogDescription>
            {defaultDescription}
            {consequences && (
              <span className="mt-3 block break-words">{consequences}</span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('cancel')}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {confirmLabel ?? t('deleteAction')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}